
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/changelog",
      function () {
        return require("private-next-pages/docs/changelog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/changelog"])
      });
    }
  